export default __webpack_public_path__ + "static/media/2-3_image8.8d6503f3.png";